module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_306153.0dc78535.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSat/FormatoSimplificado_306153.pdf
// module id = 821
// module chunks = 0